import { Error as ErrorI } from '@abiglobalhealth/go-types'
import { useContext } from 'react'

import { ErrorsContext } from '@/contexts/error'

interface UseGeneralErrorsProps {
  generalErrors: ErrorI[] | null
  addGeneralError: (error: ErrorI) => void
  clearGeneralErrors: () => void
}

export const useGeneralErrors = (): UseGeneralErrorsProps => {
  const { generalErrors, setGeneralErrors } = useContext(ErrorsContext)

  const clearGeneralErrors = () => {
    if (!generalErrors) return
    setGeneralErrors(null)
  }

  const addGeneralError = (error: ErrorI) => {
    setGeneralErrors((prev) => {
      if (!prev) return [error]

      return [...prev, error]
    })
  }

  return {
    generalErrors,
    addGeneralError,
    clearGeneralErrors
  }
}
